export default __webpack_public_path__ + "735b8e00df672c0ab1796e699f7c1c58.webp";